export default __webpack_public_path__ + "static/media/ResearchThumbnail1.306959c5.jpg";